<template class="body">
  <div>
    <b-container>
      <b-row class="header">
        <!-- Kép -->
        <b-col cols="12" lg="12">
          <img src="../assets/img/Demjan.jpg" style="max-width: 100%;" />
        </b-col>
      </b-row>
      <!-- címek -->
      <b-row class="body">
        <!-- DEMJÁN SÁNDOR TŐKEPROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button class="buttonScroll" @click="scrollToSection('section-1')">
                <b-col cols="12" lg="11"><span class="name">DEMJÁN SÁNDOR</span> TŐKEPROGRAM</b-col>
                <b-col cols="12" lg="1">
                  <span>
                    <ChevronRightIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR 1+1 BERUHÁZÁS-ÉLÉNKÍTŐ TÁMOGATÁSI PROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-2')" class="buttonScroll">
                <b-col cols="12" lg="11">
                  <span class="name">DEMJÁN SÁNDOR</span> „1+1” KKV BERUHÁZÁS-ÉLÉNKÍTŐ TÁMOGATÁSI PROGRAM
                </b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion2">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion2">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR MINDEN VÁLLALKOZÁSNAK LEGYEN SAJÁT HONLAPJA PROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-3')" class="buttonScroll">
                <b-col cols="12" lg="11">
                  <span class="name">DEMJÁN SÁNDOR</span> „MINDEN VÁLLALKOZÁSNAK LEGYEN SAJÁT HONLAPJA” PROGRAM
                </b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion3">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion3">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR SZÉCHENYI KÁRTYA PROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-4')" class="buttonScroll">
                <b-col cols="12" lg="11">
                  <span class="name">DEMJÁN SÁNDOR</span> KEDVEZMÉNYES (3,5%) SZECHENYI KÁRTYA
                </b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion4">
                    <ChevronRightIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR EXPORTÖSZTÖNZŐ HITELPROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-5')" class="buttonScroll">
                <b-col cols="12" lg="11"><span class="name">DEMJÁN SÁNDOR</span> EXPORTÖSZTÖNZŐ HITELPROGRAM</b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion5">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion5">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-6')" class="buttonScroll">
                <b-col cols="12" lg="11">
                  <span class="name">DEMJÁN SÁNDOR</span> KIFEKTETÉST TÁMOGATÓ HITEL- ÉS TŐKEPROGRAM
                </b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion6">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion6">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-7')" class="buttonScroll">
                <b-col cols="12" lg="11"><span class="name">DEMJÁN SÁNDOR</span> UNIÓS TÁMOGATÁSI PROGRAMOK</b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion7">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion7">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-7')" class="buttonScroll">
                <b-col cols="12" lg="11">
                  <span class="name">DEMJÁN SÁNDOR</span> KKV ADMINISZTRÁCIÓS TERHEINEK CSÖKKENTÉSE
                </b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion8">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion8">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button @click="scrollToSection('section-9')" class="buttonScroll">
                <b-col cols="12" lg="11">
                  <span class="name">DEMJÁN SÁNDOR</span> MIKROVÁLLALKOZÁSOK ÁRAMÁRAINAK CSÖKKENTÉSE
                </b-col>
                <b-col cols="12" lg="1">
                  <span v-if="!isOpenAccordion8">
                    <ChevronRightIcon :size="30" />
                  </span>
                  <span v-if="isOpenAccordion8">
                    <ChevronDownIcon :size="30" />
                  </span>
                </b-col>
              </button>
            </b-card-header>
          </b-row>
        </b-col>
      </b-row>
      <!-- tartalmak -->
      <b-row class="body">
        <b-col cols="12" lg="12" id="section-1">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>KKV tőkefinanszírozási program</h4>
                <p>
                  A vállalkozások komolyabb mértékű, méretugrásukat támogató fejlesztéseinek speciális támogatása
                  keretében az állam 1%-os, jelképes tulajdonrész szerzése mellett biztosít 6 éves időtartamra olcsó,
                  nagyösszegű fejlesztési forrást alárendelt kölcsöntőke juttatás keretében.
                </p>
                <p>
                  A lehetőség iparági megkötöttség és széles körű beruházási célra biztosít viszonylag nagy összegű,
                  100-200 millió forintos friss forrást évi 5%-os kamatozás mellett. A tőkefinanszírozás révén a
                  vállalkozás hitelképessége javul.
                </p>
                <button class="link" @click="openLink('https://mkik.hu/tokeprogram')" target="_blank">
                  Tovább a programra
                </button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-2">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>„1+1” KKV Beruházás-élénkítő Támogatási Program</h4>
                <p>
                  A program a hazai tulajdonú, mikro-, kis- és középvállalkozások eszközberuházásait támogatja annak
                  érdekében, hogy termelési kapacitásuk fejlődjön, magasabb hozzáadott értékű termékek gyártására
                  nyíljon lehetőség. Egy vállalkozás 5-200 millió forint támogatásban részesülhet. A vállalkozás
                  beruházásnak 50%-át az állam vissza nem térítendő támogatásként biztosítja.
                </p>
                <p>
                  A program elsődlegesen eszközbeszerzést támogat, emellett digitalizációs és megújuló energiával
                  kapcsolatos fejlesztések is finanszírozhatóak.
                </p>
                <button class="link" @click="openLink('https://www.vali.hu/egypluszegy-program')" target="_blank">
                  Tovább a programra
                </button>
                <!-- <h5>Részletek hamarosan!</h5> -->
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-3">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>„Minden vállalkozásnak legyen saját honlapja” program</h4>
                <p>
                  A program célja csökkenteni a hazai kkv-k digitalizációs elmaradását az uniós versenytársakhoz képest
                  – hazánkban a 10 fő feletti vállalkozások kétharmada rendelkezik saját honlappal, az EU közel 80%-os
                  átlagához képest – aki ma nincs jelen az interneten, vagy a social média felületein, sokkal kisebb
                  eséllyel talál magának ügyfelet.
                </p>
                <p>
                  A program keretében a kormány két éves időtartamra átvállalja az internetes megjelenés támogatásához
                  szükséges digitális eszközök (webcím, tárhely, email) szolgáltatói költségeit, támogatást nyújt a
                  weboldal és a social média felületek arculati és tartalomfejlesztéshez, a kibervédelmi, illetve az
                  internetes értékesítést támogató szolgáltatások igénybevételéhez.
                </p>
                <button class="link" @click="openLink('https://palyazat.neum.hu')" target="_blank">
                  Tovább a programra
                </button>
                <!-- <h5>Részletek hamarosan!</h5> -->
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-4">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>Széchenyi Kártya Program 3,5 százalékos beruházási hitelkamat</h4>
                <p>
                  A beruházások ösztönzése érdekében november 1-től 5 százalékról 3,5 százalékra csökken az ügyfelek
                  által fizetendő éves kamat a Széchenyi Kártya program beruházást támogató hitelelemeinél:
                </p>
                <ul>
                  <li>Széchenyi Beruházási Hitel MAX+,</li>
                  <li>Széchenyi Lízing MAX+,</li>
                  <li>Széchenyi Mikrohitel MAX+,</li>
                  <li>Agrár Széchenyi Beruházási Hitel MAX+.</li>
                </ul>
                <p>
                  A még kedvezményesebb kamatozás mellet a 2025. június 30-ig Széchenyi Kártya beruházási hiteltermékeit
                  igénylő vállalkozások számára az első évben díjmentesen nyújtja a hitelhez kötelezően kapcsolt
                  kezesség kezességvállalását a Garantiqa Hitelgarancia Zrt.
                </p>
                <button class="link" @click="openLink('https://www.kavosz.hu')" target="_blank">
                  Tovább a programra
                </button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-5">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>Exportösztönző Hitelprogram</h4>
                <p>
                  A Demján Sándor Program keretében az EXIM újraindítja korábbi nagysikerű termékeit, amelyeket
                  exportáló és nem exportáló vállalkozások is igénybe vehetnek beruházási, zöld beruházási és lízing
                  célokra.
                </p>
                <ul>
                  <span>Termékek:</span>
                  <li>EXIM Jövő Exportőrei Beruházási és Zöld Beruházási Hitel</li>
                  <li>EXIM Exportélénkítő Beruházási Hitel és Lízing</li>
                </ul>
                <button class="link" @click="openLink('https://exim.hu/demjan-sandor-program/')" target="_blank">
                  Tovább a programra
                </button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-6">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>Kifektetést támogató (Exim) hitel- és (NTH) tőkeprogram</h4>
                <p>
                  A program keretében külpiaci beruházások, cégalapítások, cégfelvásárlások (kifektetés) támogathatóak,
                  amelyek új piacok szerzésével, terjeszkedéssel segítik a vállalkozások versenyképességének növelését,
                  a cég növekedési pályára állását, a bevételi források és kockázatok diverzifikációját. Nem titkolt cél
                  magyar multik, nemzeti bajnok vállalkozások kinevelése.
                </p>
                <p>
                  EXIM Kifektetési Hitel:
                  <button class="link" @click="openLink('https://exim.hu/demjan-sandor-program/')" target="_blank">
                    Tovább a programra
                  </button>
                </p>
                <p>
                  Tőkebefektetés a határokon átívelő beruházásokért:
                  <button
                    class="link"
                    @click="openLink('https://focusventures.hu/nemzetkozi-lehetosegek')"
                    target="_blank"
                  >
                    Tovább a programra
                  </button>
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-7">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>Vállalkozásfejlesztési uniós programok</h4>
                <p>
                  A magyarországi kkv-szektor számára 2025-ben 650 milliárd forintnyi uniós forrás kihelyezésére nyílik
                  lehetőség vissza nem térítendő támogatás, támogatott hitel, illetve ezek kombinációja révén.
                </p>
                <!--button class="link" @click="openLink('www.palyazat.gov.hu')" target="_blank">
                  Tovább a programra
                </button-->
                <h5>Részletek hamarosan!</h5>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-8">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>KKV adminisztrációs terheinek csökkentése</h4>
                <p>
                  A Nemzetgazdasági Minisztérium a vállalkozói szakmai és érdekképviseleti szervezetekkel országszerte
                  és folyamatosan konzultálva felmérjük és összegyűjtjük a KKV-k javaslatait és igényeit az őket terhelő
                  adminisztráció csökkentésére, és működési környezetük egyszerűsítésére vonatkozóan.
                </p>
                <p>
                  Az adminisztrációcsökkentés kiemelt fókuszterületei:
                </p>
                <ul>
                  <li>adatszolgáltatás</li>
                  <li>jogszabályi környezet</li>
                  <li>adózási adminisztráció</li>
                </ul>
                <!--button class="link" @click="openLink('www.palyazat.gov.hu')" target="_blank">
                  Tovább a programra
                </button-->
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col cols="12" lg="12" id="section-9">
          <div class="offer-description mt-2">
            <b-row class="blockBox">
              <b-col class="m-2">
                <competition-small-details :competition="offer" />
                <h4>Mikrovállalkozások áramárainak csökkentése</h4>
                <p>
                  2025. január 1-jétől újabb mikrovállalkozások válnak jogosulttá a villamos energia egyetemes
                  szolgáltatás igénybevételére, akik 2022. június 18-án nem egyetemes szolgáltatótól vételeztek, vagy
                  ezen dátumot követően alakultak meg. Ennek köszönhetően számos további mikrovállalkozás kaphatja az
                  áramot az olcsóbb, rezsicsökkentett, azaz a nem lakossági egyetemes szolgáltatás árképzésének
                  megfelelő áron, a 4 606 kWh éves fogyasztásig.
                </p>
                <!--button class="link" @click="openLink('www.palyazat.gov.hu')" target="_blank">
                  Tovább a programra
                </button-->
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'

export default {
  name: 'demjensandorprogram',
  components: {
    ChevronDownIcon,
    ChevronRightIcon
  },
  metaInfo: {
    title: 'Demján Sándor Program'
  },
  data() {
    return {
      offer: {}
    }
  },
  mounted() {
    document.title = 'Demján Sándor Program'
  },
  methods: {
    // Az oldalra történő görgetés az adott szakaszra
    scrollToSection(id) {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // A link megnyitása új ablakban
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.link {
  color: white;
}

.dspspan {
  font-size: larger;
  font-weight: bold;
}

.header {
  background-color: #bee4e3;
}

.header h1 {
  color: #39455e;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-size: 4vw;
  font-weight: bold;
  letter-spacing: -1px;
}

.header h2 {
  color: #4e8896;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  font-size: 3vw;
}

.link {
  background-color: #a27e5b;
  border-radius: 5px;
  color: white;
  font-family: Arial;
  border: none;
  cursor: pointer;
  height: 40px;
  width: auto;
}

.buttonScroll {
  all: unset; /* Eltávolítja az alapértelmezett stílusokat */
  background-color: transparent; /* Alapértelmezett háttér eltávolítása */
  display: flex; /* Flexbox használata */
  align-items: center; /* Függőleges középre igazítás */
  justify-content: space-between; /* Kiegyenlíti a tartalmat a sor végére */
  width: 100%; /* A teljes szélességet kitölti */
  font-size: large;
  margin: 15px;
}

.buttonScroll b-col {
  display: flex;
  align-items: center; /* Függőleges igazítás minden b-col elemnél */
}

.box-Role {
  padding: 0; /* Eltávolítja a paddingot a card header-ből */
  border: none; /* Eltávolítja a szegélyeket, ha nem szükségesek */
  display: flex; /* Flexbox aktiválása a header-en belül */
  justify-content: space-between; /* Rendezi a gyermekelemeket egy sorba */
  align-items: center; /* Igazítja a tartalmat függőlegesen */
  width: 100%; /* A teljes szélességet kitölti */
  background: #4e8896;
}

.blockBox {
  margin: 20px;
}

.body {
  background: #4e8896;
  color: white;
  text-align: left;
}
.name {
  color: #bfe6e5;
}
</style>
